module.exports = __webpack_public_path__ + "static/media/e388ac99-8c6a-4451-8690-1d15b4d45adb.d7a47c7d.woff";